/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterVSmall = createReactComponent("outline", "letter-v-small", "IconLetterVSmall", [["path", { "d": "M10 8l2 8l2 -8", "key": "svg-0" }]]);

export { IconLetterVSmall as default };
//# sourceMappingURL=IconLetterVSmall.mjs.map
